import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { ApiService } from '../../services/api.service';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-share-pds-pru',
  standalone: false,
  templateUrl: './share-pds-pru.component.html',
})
export class SharePdsPruComponent {
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() schemeType: string;
  @Input() proposalName: any;
  @Input() id: any;
  @Input() format: any;
  @Input() proposalId: any;
  @ViewChild('table') table!: Table;
  userID: any;
  baseUrl = environment.APIUrl;
  private subscriptions = new Subscription();
  docuemntList: any;
  winners = [
    {
      id: 1,
      applicantName: 'Rohit Sharma',
      companyName: 'TechVision Pvt Ltd',
      pdsFileId: '',
      pruFileId: '',
      sharedOnIdex: false,
      notes: '',
    },
    {
      id: 2,
      applicantName: 'Anjali Mehra',
      companyName: 'InnoTech Solutions',
      pdsFileId: '',
      pruFileId: '',
      sharedOnIdex: true,
      notes: 'Pending confirmation',
    },
  ];
  vendorTableColumns = [
    { field: 'vendor.name', header: 'Vendor Name' },
    { field: 'vendor.contact', header: 'Contact' },
    { field: 'vendor.email', header: 'Email' },
    { field: 'document_receive', header: 'Document Received' },
    { field: 'vendor_status', header: 'Status' },
  ];
  vendorTableRows: any[] = [];
  hasDocumentActions = false;


  constructor(
    private messageService: MessageService,
    private apiService: ApiService
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit() {
    this.getData();
  }

    toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }
    expandedSections: { [key: string]: boolean } =
    {
      basicInfo: true,
      vendorTable: false,
    };

  goToNextStep() {
    this.stepCompleted.emit();
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }
  editRow(row: any) {
    row.editing = true;
  }

  saveRow(row: any, index: number, table: any) {
    console.log('Saved row:', row);
    const formData = new FormData();

    formData.append('id', row.id);
    if (this.format == 'upload') {
      // if (row.pds) {
        formData.append('pds', row.pds); // Make sure it's a File object
      // }
      // if (row.pru) {
        formData.append('pru', row.pru); // Also a File object
      // }
    } else {
      formData.append('send_idex', row.send_idex);
      formData.append('remarks', row.remarks);
    }
    const sub = this.apiService
      .putAPI(`/idex/sharing/pds-pru/`, formData)
      .subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Vendor updated successfully',
          });
          this.getData(); // refresh the table
        },
        error: (err) => {},
      });
    row.editing = false;
    table.cancelRowEdit(row);
    // 👉 call API here to save row data
  }

  onFileUpload(event: any, row: any, field: string) {
    const file = event.files[0];
    if (file) {
      // Normally send to backend and get fileId
      row[field] = file; // For now, just store name
      console.log(`Uploaded ${field} for`, row.applicantName, ':', file.name);
    }
  }

  download(file: string, filename: string) {
    console.log('Downloading', file, 'as', filename);
    // 👉 backend call for file download
  }
  challengesFormData: any;
  winnersVendorData: any;
  getData() {
    let url = this.format == 'upload' ?
    `/idex/upload/compliance/pds-pru/?proposal_step=${this.id}&proposal_step__proposal=${this.proposalId}` : `/idex/sharing/pds-pru/?proposal_step=${this.id}&proposal_step__proposal=${this.proposalId}` ;
    const sub = this.apiService.getAPI(url).subscribe((resp: any) => {
      this.docuemntList = resp;
      this.challengesFormData = resp.challenge_data;
      this.winnersVendorData = resp.vendor_data;
      // this.winners = resp.data;
      this.winners = resp.data.map((row: any) => {
      // If file URLs or filenames are returned, assign to the appropriate fields
      row.pruFileId = row.pru ? row.pru.name || row.pru : null; // adjust key depending on API
      row.pdsFileId = row.pds ? row.pds.name || row.pds : null;
      return row;
    });
    });
    this.subscriptions.add(sub);
  }
  onMultipleFileUpload(event: any, row: any) {
  // Assuming you want to handle multiple files here
  const uploadedFiles = event.files;
  if (!row.documents) {
    row.documents = [];
  }

  uploadedFiles.forEach((file: any) => {
    row.documents.push({
      fileId: file.fileId, // Assuming fileId is returned in the response
      fileName: file.name
    });
  });
}

recivedDocument(obj: any){
  this.apiService.putAPI(`/idex/sharing/pds-pru/`, {
    id: obj.id,
    document_receive: true
  }).subscribe(res=>{
        this.messageService.add({ severity: 'success',  summary: 'Success',     detail: res.message || 'Document received successfully',    });
        this.getData();
  })
    
}

}
